import React, { useState } from "react";
import "./FaceUpload.scss";

export default function FaceUpload({ updateObjects, addImgToSubject, current }) {
    const [dragActive, setDragActive] = useState(false);
    const [images, setImages] = useState([]);
    const inputRef = React.useRef(null);

    const handleDrag = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    const handleDrop = function (e) {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            setImages(e.dataTransfer.files);
            addImgToSubject({ image: e.dataTransfer.files[0], subject: current.subject, current });
        }
    };

    const handleChange = function (e) {
        e.preventDefault();
        if (e.target.files && e.target.files[0]) {
            setImages(e.target.files);
            addImgToSubject({ image: e.target.files[0], subject: current.subject, current });
        }
    };

    const onButtonClick = () => {
        inputRef.current.click();
    };

    const onSubmitClick = (e) => {
        e.preventDefault();
        // updateObjects({ images });
        // addImgToSubject({ image: images[0], subject: current.subject });
    }

    return (
        <div className="FaceUpload">
            <form id="faceupload-form" onDragEnter={handleDrag} onSubmit={onSubmitClick}>
                {/* <div className="faceupload-actions">
                    <button className="faceupload-btn" type="submit">Face Detection</button>
                </div> */}
                <input ref={inputRef} type="file" id="faceupload-input" multiple={true} onChange={handleChange} />
                <label id="faceupload-label" htmlFor="faceupload-input"
                    className={dragActive ? "faceupload-drag-active" : ""}>
                    <div>
                        <button className="faceupload-button" onClick={onButtonClick}>
                            Click here or Drag and drop your image
                        </button>
                    </div>
                </label>
                {dragActive && <div id="faceupload-dragfile-elem" onDragEnter={handleDrag}
                    onDragLeave={handleDrag} onDragOver={handleDrag} onDrop={handleDrop}></div>}
            </form>
        </div>
    );
};
